import React, { useState, useRef, useEffect } from "react";
import "./enamad.css";

export default function FooterCertificate({
  text = `نماد اعتماد الکترونیکی؛ تضمین امنیت اطلاعات و پرداخت‌های مطمئن در فروشگاه صنایع دستی گوهر صدف دریا.`,
  collapsedHeight = 84, // px - adjust how tall the collapsed area is
}) {
  const [expanded, setExpanded] = useState(false);
  const contentRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState(`${collapsedHeight}px`);
  const id = "certificate-content";

  // update measured height when expanding/collapsing or when content size changes
  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    const update = () => {
      if (expanded) {
        // expand to full natural height
        setMaxHeight(`${el.scrollHeight}px`);
      } else {
        // collapse
        setMaxHeight(`${collapsedHeight}px`);
      }
    };

    // initial update
    update();

    // watch for content / window size changes
    const ro = new ResizeObserver(update);
    ro.observe(el);
    window.addEventListener("resize", update);

    return () => {
      ro.disconnect();
      window.removeEventListener("resize", update);
    };
  }, [expanded, collapsedHeight]);

  return (
    <div className={`footer-certificate modern ${expanded ? "is-expanded" : ""}`}>
      <div className="certificate-text" aria-hidden={false}>
        <div
          id={id}
          ref={contentRef}
          className="certificate-content"
          style={{ maxHeight }}
        >
          <div className="certificate-inner">
            {/* Keep markup flexible - you can pass HTML if you change rendering accordingly */}
            <p>{text}</p>
            <p>
              این وبسایت دارای نماد اعتماد الکترونیکی می‌باشد. وجود این نماد به معنای اعتبار، امنیت و پایبندی فروشگاه به قوانین تجارت الکترونیک است. تمامی اطلاعات شخصی و مالی کاربران با رعایت اصول محرمانگی و بر اساس قوانین حفاظت از داده‌ها نگهداری می‌شود و هیچ‌گونه دسترسی غیرمجاز به آنها امکان‌پذیر نیست.

تمامی فرایندهای پرداخت در فروشگاه صنایع دستی ما از طریق درگاه‌های امن بانکی و به صورت رمزنگاری‌شده انجام می‌شود. بدین ترتیب شما می‌توانید با خیالی آسوده سفارش خود را ثبت کرده و پرداخت را تکمیل نمایید.

نماد اعتماد الکترونیکی به شما اطمینان می‌دهد که این فروشگاه آنلاین تمامی استانداردهای لازم را برای ارائه خدمات مطمئن و شفاف رعایت می‌کند. این اعتماد به شما اجازه می‌دهد تا با آرامش خاطر، آثار اصیل هنرمندان ایرانی را خریداری کنید و مطمئن باشید که هر خرید شما به طور مستقیم از هنرمندان حمایت می‌کند.

شما می‌توانید برای مشاهده جزئیات و اطمینان بیشتر، روی لوگوی نماد اعتماد کلیک کنید و اطلاعات مربوط به اعتبار فروشگاه را به طور کامل بررسی نمایید.
            </p>
          </div>
        </div>

        <div className="certificate-controls">
          <button
            className={`expand-btn`}
            aria-expanded={expanded}
            aria-controls={id}
            onClick={() => setExpanded((s) => !s)}
          >
            <span className="btn-label">
              {expanded ? "کمتر" : "بیشتر"} {/* Persian labels */}
            </span>
            <span className={`chev ${expanded ? "rotated" : ""}`} aria-hidden="true">
              ▾
            </span>
          </button>
        </div>
      </div>

      <div className="certificate-logo">
        <a
          referrerPolicy="origin"
          target="_blank"
          rel="noopener noreferrer"
          href="https://trustseal.enamad.ir/?id=643781&Code=hd6xpNYqtqAgfmeIYrPbvV9JXQvkYSDs"
          title="بازدید نماد اعتماد"
        >
          <img
            referrerPolicy="origin"
            src="https://trustseal.enamad.ir/logo.aspx?id=643781&Code=hd6xpNYqtqAgfmeIYrPbvV9JXQvkYSDs"
            alt="enamad logo"
          />
        </a>
      </div>
    </div>
  );
}
